// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:29.855144
var courses = [
    {
        "course_id": "36B3E48D-7A8B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP - ENP Procedures Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Procedural confidence is built, not assumed. The ENP Procedures Bundle delivers technique-focused instruction across airway, anesthesia, wound closure, ultrasound, and imaging interpretation \u2014 the skills emergency and urgent care providers reach for on every shift. Each course is developed and taught by experts in emergency care, with practical guidance you can apply at the bedside immediately. \r\n\r\n13 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D8A5F94A-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - ENP Procedures - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - ENP Procedures Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "55471635-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Basic Suturing: Foundational Skills for APPs",
                "course_type": 1,
                "author_information": "Jolene Dodd, MSN, APRN, FNP-C, AGACNP-BC, ENP-C",
                "description": "This course focuses on the evaluation and management of lacerations, emphasizing accurate wound assessment and identification of characteristics that influence closure decisions, including situations where primary repair should be avoided. Learners will practice simple interrupted and running sutures, review proper irrigation and wound cleansing techniques to reduce infection risk, and apply best practices in documentation, discharge instructions, follow-up care, and medicolegal considerations.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Accurately assess and describe lacerations</li>\r\n    <li> Identify key wound characteristics that guide closure decisions and when to avoid primary repair</li>\r\n    <li>Demonstrate correct techniques for simple interrupted and running sutures</li>\r\n    <li>Recognize proper irrigation methods and wound cleansing practices to reduce infection risk</li>\r\n    <li>Apply best practices in documentation, follow-up instructions, and medicolegal considerations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "92156A87-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Ischemic Arm Block for Closed Wrist Fracture",
                "course_type": 1,
                "author_information": "Shawn Schoppe, DNP, APRN, FNP-C, ENP-C, LP",
                "description": "This presentation will describe the Bier\u2019s Block, along with its contraindications. Best practices will be highlighted as well as benefits and effectiveness.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe indications and contraindications for Bier&rsquo;s Block</li>\r\n    <li>Describe procedure for Bier&rsquo;s Block</li>\r\n    <li>Describe benefits to using a Bier&rsquo;s Block</li>\r\n    <li>Credit Designations</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D9C04975-413C-11DD-9765-001517135727",
                        "course_category_name": "Orthopedic Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pain Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "D1542803-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Advancing Pain Management in Emergency Medicine: Innovative Approaches to Regional Anesthesia",
                "course_type": 1,
                "author_information": "David Warren, DNP, CRNA, FNP, ACNP, ENP",
                "description": "This session explores innovative regional anesthesia techniques for acute and chronic pain in the ED. NPs will learn indications, pharmacology, and ultrasound-guided approaches through case studies to enhance pain control and patient outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Explore basic and advanced regional anesthesia techniques: Learn about the latest advancements in regional anesthesia, including ultrasound-guided nerve blocks, local anesthetic pharmacology, and their applications in the ED setting.</li>\r\n    <li>Implement innovative pain management strategies: Develop the ability to apply new techniques and tools for regional anesthesia to improve pain management and patient outcomes in the emergency department.</li>\r\n    <li>Optimize efficiency and safety: Analyze how advanced regional anesthesia techniques can reduce the need for systemic opioids and enhance overall efficiency and safety in patient care in the emergency department. Discuss local anesthetic systemic toxicity (LAST) and it&rsquo;s treatment.</li>\r\n    <li>Address and mitigate contraindications to regional anesthesia: Identify and address specific contraindications to regional anesthesia.</li>\r\n    <li>Specific regional anesthetic blocks: Utilize evidence-based approaches to compare and contrast different regional anesthetic techniques that can be utilized in emergency medicine, including upper extremity blocks, lower extremity blocks, and truncal blocks</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6C3323AC-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Pain Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "31887D19-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Basic EKG Interpretation for the ENP",
                "course_type": 1,
                "author_information": "Jolene Traum, ENP-C",
                "description": "This course focuses on basic anatomy, electrical pathways, components of the 12 lead EKG, and EKG patterns. This course will go over recognition of EKG patterns, causes, and meanings.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe the electrical pathway of the heart</li>\r\n    <li>Describe the components of a normal 12 lead EKG</li>\r\n    <li>Relate components of EKG to cardiac anatomy</li>\r\n    <li>Recognize patterns, meanings, and potential causes of EKGs</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6133B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Cardiac Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "BEAAF648-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Treating Dental Pain in the Emergency Department",
                "course_type": 1,
                "author_information": "Erica May, DNP, APRN, FNP-BC, AGACNP-BC, ENP-C",
                "description": "This course addresses the evaluation and management of acute, non-traumatic dental pain in the emergency department. Learners will review criteria for identifying dental pain presentations, apply evidence-based pharmacologic guidelines for pain control, and discuss the indications and techniques for supraperiosteal, mental, and inferior alveolar dental nerve blocks.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Recognize patients with acute non-traumatic dental pain the  ED</li>\r\n    <li>Apply a published guideline for the pharmacological management of dental pain in the ED</li>\r\n    <li>Discuss supraperiosteal, mental, and inferior alveolar dental nerve blocks</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6529FF26-21FE-E611-A7FF-005056B16BE3",
                        "course_category_name": "Mouth Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "99E6968A-02C9-E511-8771-005056B104B1",
                        "course_category_name": "Dental Health",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "05B788BA-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Point-of-Care Ultrasound in High-Altitude Sickness (HAI): A Lifesaving Tool in Extreme Environments",
                "course_type": 1,
                "author_information": "Ari Chaskes, DNP, FNP-BC, ENP-C, NRAEMT",
                "description": "This presentation will begin with a refresher on HAI followed by an explanation of using POCUS to diagnose and monitor in these environments. Practical considerations and challenges will be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key clinical features of high-altitude illness, including acute mountain sickness (AMS), high-altitude pulmonary edema (HAPE), and high-altitude cerebral edema (HACE).</li>\r\n    <li>Explain the principles and advantages of point-of-care ultrasound (POCUS) as a diagnostic and monitoring tool in remote, high-altitude environments.</li>\r\n    <li>Identify specific POCUS applications relevant to high-altitude illness, such as:\r\n    <ul>\r\n        <li>a.  Pulmonary assessment for B-lines in HAPE</li>\r\n        <li>b.  Cardiac evaluation for right heart strain</li>\r\n        <li>c.  Optic nerve sheath diameter (ONSD) measurement for HACE.</li>\r\n    </ul>\r\n    </li>\r\n    <li>Discuss the practical considerations, challenges, and limitations of using POCUS in austere, high-altitude settings.</li>\r\n    <li>Recognize future directions and opportunities for research and technology development that can expand POCUS use in wilderness and expedition medicine.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.25,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "833E5FD4-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Radiology Essentials: Interpretation of Common and Can't Miss Imaging",
                "course_type": 1,
                "author_information": "Stephen Jameson, MD, FACEP",
                "description": "Interpretation of radiographic imaging is a skill every emergency provider needs to possess. In this session you will review a multitude of common and can't miss radiographic studies and the clinical context within which they were obtained. This is true experiential learning as you see true life cases and their associated images. It's a can't miss presentation.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe radiographic findings on standard imaging</li>\r\n    <li>For better communication between colleagues</li>\r\n    <li>For improved clarity of diagnosis &amp; billing</li>\r\n    <li>Interpret radiographic studies of many common conditions</li>\r\n    <li>State how the appropriate use of imaging can help diagnose several can&rsquo;t miss diagnoses</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F36CA5E2-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Advanced Suturing: EM Advanced Suturing Techniques",
                "course_type": 1,
                "author_information": "Jolene Dodd, MSN, APRN, FNP-C, AGACNP-BC, ENP-C",
                "description": "This course provides hands-on instruction in advanced suturing and wound repair techniques. Learners will practice horizontal and vertical mattress sutures, corner stitches, buried sutures, and the palming technique to improve precision and control. Emphasis is placed on cosmetic and high-tension wound management, including vermillion border, nailbed, and finger injuries, with instruction in digital nerve blocks and nail plate stabilization.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Perform advanced suturing techniques including horizontal mattress, vertical mattress, corner stitch, and buried sutures.</li>\r\n    <li>Apply effective strategies for cosmetic and high-tension wound repairs including vermillion border and nailbed lacerations.</li>\r\n    <li>  Execute the palming technique to enhance dexterity and control during suturing.</li>\r\n    <li> Demonstrate knowledge of finger and hand injury repair including digital nerve blocks and nail plate stabilization.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "F60F215D-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Don't CRASH Your Patient! Mitigating the Physiologically Difficult Airway",
                "course_type": 1,
                "author_information": "Jacob Miller, DNP, MBA, ACNP, ENP-C, CNS, NRP",
                "description": "Nearly all airway courses focus on the physical task of intubation. Similarly, most \"difficult airway\" courses cover psychomotor and procedural challenges encountered in airway management. Here, we focus on the physiologic difficulties that can lead to clinical deterioration during the peri-intubation period and how to mitigate them. Next time you have to perform airway management, don't allow your patient to CRASH -- make sure their physiology has been optimized first!",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Differentiate anatomic from physiologic airway management difficulties</li>\r\n    <li>Identify risk factors predicting physiologic difficulty using the CRASH and HOp mnemonics</li>\r\n    <li>Formulate a treatment plan to prevent peri-intubation arrest in the physiologically challenging patient</li>\r\n    <li>Compare and contrast airway management strategies in the medical versus trauma patient</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-000000001090",
                        "course_category_name": "Airway Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "70D08E73-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Clinical Integration of POCUS for Musculoskeletal Complaints in the ED",
                "course_type": 1,
                "author_information": "Kelly Craven, DNP, ENP, FNP, NRP",
                "description": "This course will examine the use of ultrasound to assist in the diagnosis and management of various musculoskeletal injuries in the ED.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>\r\n    Identify appropriate use of point of care ultrasound (POCUS)\r\n    </li>\r\n    <li>Describe the mechanics of ultrasound\r\n    </li>\r\n    <li>Describe the evaluation of shoulder anatomy using POCUS\r\n    </li>\r\n    <li>Identify common imaging findings associated with shoulder dislocation </li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "437DEC7D-A8BA-E811-9AF1-005056B1456A",
                        "course_category_name": "Medical Imaging",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "C6C823A0-DF17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Nail Procedures for ED & Urgent Care Providers",
                "course_type": 1,
                "author_information": "Amanda Hitt, DNP, FNP-C, ENP-C",
                "description": "This course will take the viewer through common nail procedures that present to EDs and urgent care centers. The course will discuss the procedures, including digital blocks, preparation considerations, contraindications, and more.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify nail procedures commonly performed in the ED and Urgent Care settings.</li>\r\n    <li>Discuss methods for placing a digital block.</li>\r\n    <li>Understand indications and management of various nail procedures.</li>\r\n    <li>Identify important considerations for practice, including scope, consultations, and referrals.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EF3008FA-83E5-E511-8C5E-005056B12B9C",
                        "course_category_name": "Wound Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.2,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "800304EE-DF17-F111-99AB-005056A70840",
                "course_version": 2,
                "name": "To See or Not to See: Eye Trauma",
                "course_type": 1,
                "author_information": "Karen O\u2019Connell Schill, DNP, FNP-BC, ENP-C, CEN, CFRN, NREMT & Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "This course evaluates different types of eye trauma. Evaluation tools and treatment options for various eye trauma will be discussed.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Understanding the different types of eye trauma</li>\r\n    <li>Describe evaluation tools and assessment tools</li>\r\n    <li>List appropriate treatment options for each eye trauma injury</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Procedures",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6527E533-CFC9-E511-82AF-005056B150D3",
                        "course_category_name": "Ear, Eye, Nose and Throat Disorders",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.8,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "3D506354-1717-F111-99A8-005056A7C0C7",
                "course_version": 1,
                "name": "Advanced Airway Management in Emergency Care Settings",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, ACNP-BC, FNP-BC, FAANP, FAEN",
                "description": "Advanced airway management is the most common life saving intervention performed in emergency care settings. Unfortunately, this intervention does not come without risks. This presentation will review current recommended practices to improve success and reduce complications, especially hypoxia and hypotension. Airway assessment, preparation and planning, medication selection, and a brief overview of ventilator management will be included. At the conclusion of this presentation, emergency nurse practitioners will be better prepared to manage airways, reduce complications, and improve outcomes.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Explain the priorities of airway management.\r\n    </li>\r\n    <li>Recall pharmacotherapeutic properties of medications used with advanced airway management.\r\n    </li>\r\n    <li>Plan appropriate interventions for patients with impaired airway and ventilations.\r\n    </li>\r\n    <li>Evaluate the effectiveness of interventions for patients with impaired airway and ventilation.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9C767BA3-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "952AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Procedures Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "FFFFFFFF-FFFF-FFFF-FFFF-000000001090",
                        "course_category_name": "Airway Management",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B56653D-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Procedures - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];